import '../App.scss';

const RightsideMenu = () => {
  return (
    <div className="rightsideMenu">
    </div>
  );
}

export default RightsideMenu;